import { Fragment } from "react";
import { NavDropdown } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { formatText } from "util/helper";
import classes from "./GrandChildrenMenu.module.css";

const GrandChildrenMenu = ({
  childItem,
  index,
  showModalsHandler,
  closeModalsHandler,
  childDrop1IsOpen,
  childDrop2IsOpen,
  modalHrefHandler,
  modalTitle,
  closeChildMenuHandler,
  modalContents,
  ModalContentList,
}) => {
  return (
    <Fragment>
      <NavDropdown
        title={<FormattedMessage id={formatText(childItem.title)} />}
        className={classes["grandchild-menu-list"]}
        onMouseEnter={() => showModalsHandler(childItem, index)}
        onMouseLeave={() => closeModalsHandler(index)}
        show={
          index === 0
            ? childDrop1IsOpen
            : index === 1
            ? childDrop2IsOpen
            : false
        }
        onClick={e => {
          if (e.target.classList.contains("dropdown-toggle")) {
            modalHrefHandler(index);
          }
        }}
      >
        <div
          className={
            modalTitle === "nav_modal_title_software"
              ? classes["modal-container--software"]
              : classes["modal-container--hardware"]
          }
        >
          <h5>
            <FormattedMessage id={modalTitle} />
          </h5>
          <div className="row">
            <ModalContentList
              modalContents={modalContents}
              closeChildMenuHandler={closeChildMenuHandler}
              modalTitle={modalTitle}
            />
          </div>
        </div>
      </NavDropdown>
    </Fragment>
  );
};

export default GrandChildrenMenu;
